"use strict";

var _classCallCheck = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/georgiavramov/limechain/new-abridged/abridged/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contracts_1 = require("@abridged/contracts");

var eth_sdk_1 = require("eth-sdk");

var constants_1 = require("../constants");

var AbstractContract_1 = require("./AbstractContract");

var AccountRegistryContract = /*#__PURE__*/function (_AbstractContract_1$A) {
  _inherits(AccountRegistryContract, _AbstractContract_1$A);

  var _super = _createSuper(AccountRegistryContract);

  function AccountRegistryContract(sdk) {
    _classCallCheck(this, AccountRegistryContract);

    return _super.call(this, sdk, contracts_1.ContractNames.AccountRegistry);
  }

  _createClass(AccountRegistryContract, [{
    key: "computeAccountAddress",
    value: function computeAccountAddress(saltKey) {
      return eth_sdk_1.computeCreate2Address(this.address, eth_sdk_1.soliditySha3(saltKey), contracts_1.getContractByteCodeHash(contracts_1.ContractNames.Account));
    }
  }, {
    key: "getAccountNonce",
    value: function getAccountNonce(account) {
      return this.methods.getAccount(account).call().then(function (_ref) {
        var nonce = _ref.nonce;
        return nonce;
      });
    }
  }, {
    key: "getAccountAuthKeyType",
    value: function getAccountAuthKeyType(account, authKey) {
      return this.methods.getAccountAuthKey(account, authKey).call().then(function (_ref2) {
        var kind = _ref2.kind;
        var result = null;

        switch (kind.toNumber()) {
          case 1:
            result = constants_1.AccountAuthKeyTypes.Removed;
            break;

          case 2:
            result = constants_1.AccountAuthKeyTypes.Restricted;
            break;

          case 3:
            result = constants_1.AccountAuthKeyTypes.Owner;
            break;
        }

        return result;
      });
    }
  }, {
    key: "buildMoveFundsToAccountDepositData",
    value: function buildMoveFundsToAccountDepositData(options) {
      var account = options.account,
          nonce = options.nonce,
          token = options.token,
          value = options.value;
      return this.methods.moveFundsToAccountDeposit(account, nonce, token || eth_sdk_1.ZERO_ADDRESS, value).data;
    }
  }, {
    key: "buildSetAccountAuthKeyData",
    value: function buildSetAccountAuthKeyData(options) {
      var kind = 0;
      var account = options.account,
          nonce = options.nonce,
          authKey = options.authKey,
          type = options.type;

      switch (type) {
        case constants_1.AccountAuthKeyTypes.Removed:
          kind = 1;
          break;

        case constants_1.AccountAuthKeyTypes.Restricted:
          kind = 2;
          break;

        case constants_1.AccountAuthKeyTypes.Owner:
          kind = 3;
          break;
      }

      return this.methods.setAccountAuthKey(account, nonce, authKey, kind).data;
    }
  }, {
    key: "buildExecuteAccountTransactionData",
    value: function buildExecuteAccountTransactionData(options) {
      var account = options.account,
          nonce = options.nonce,
          recipient = options.recipient,
          value = options.value,
          data = options.data;
      return this.methods.executeAccountTransaction(account, nonce, recipient, value, data).data;
    }
  }, {
    key: "buildCommitAccountPaymentChannelData",
    value: function buildCommitAccountPaymentChannelData(options) {
      var account = options.account,
          nonce = options.nonce,
          sender = options.sender,
          token = options.token,
          uid = options.uid,
          value = options.value,
          senderSignature = options.senderSignature,
          guardianSignature = options.guardianSignature;
      return this.methods.commitAccountPaymentChannel(account, nonce, sender, token || eth_sdk_1.ZERO_ADDRESS, uid, value, senderSignature, guardianSignature).data;
    }
  }, {
    key: "buildCommitAccountPaymentChannelAndDepositData",
    value: function buildCommitAccountPaymentChannelAndDepositData(options) {
      var account = options.account,
          nonce = options.nonce,
          sender = options.sender,
          token = options.token,
          uid = options.uid,
          value = options.value,
          senderSignature = options.senderSignature,
          guardianSignature = options.guardianSignature;
      return this.methods.commitAccountPaymentChannelAndDeposit(account, nonce, sender, token, uid, value, senderSignature, guardianSignature).data;
    }
  }, {
    key: "buildRelayAccountOwnerCallData",
    value: function buildRelayAccountOwnerCallData(options) {
      var result = null;
      var data = options.data,
          refundToken = options.refundToken,
          refundAmount = options.refundAmount,
          signature = options.signature;

      switch (data.length) {
        case 1:
          result = this.methods.relayAccountOwnerCall(data[0], refundToken, refundAmount, signature).data;
          break;

        case 2:
          result = this.methods.relayAccountOwnerCall2(data[0], data[1], refundToken, refundAmount, signature).data;
          break;

        case 3:
          result = this.methods.relayAccountOwnerCall3(data[0], data[1], data[2], refundToken, refundAmount, signature).data;
          break;

        case 4:
          result = this.methods.relayAccountOwnerCall4(data[0], data[1], data[2], data[3], refundToken, refundAmount, signature).data;
          break;

        case 5:
          result = this.methods.relayAccountOwnerCall5(data[0], data[1], data[2], data[3], data[4], refundToken, refundAmount, signature).data;
          break;
      }

      return result;
    }
  }]);

  return AccountRegistryContract;
}(AbstractContract_1.AbstractContract);

exports.AccountRegistryContract = AccountRegistryContract;